export default "__VITE_ASSET__Qlnezlxa__"